module.exports = require("@splunk/dashboard-visualizations/Scatter");